<div class="content">

    <div class="d-flex justify-content-center" style="margin-left: 1%;" (click)="openAddModal()"
        style="cursor: pointer;">
        <div class="d-flex align-items-center" style="white-space: nowrap ;">
            <i class="fa-solid fa-circle-plus fa-2x"></i>
            <span class="small span-icon" style="margin-left: 7%;">Add Local Agreement</span>
        </div>

    </div>

    <div class="d-flex justify-content-center mt-4">
        <ng2-smart-table [settings]="settings" [source]="listLocalAgreements" (custom)="onCustomAction($event)">
        </ng2-smart-table>


    </div>

</div>

<ng-template #confirmDeleteAgreement let-modal>
    <div class="modal-header header-background-color">
        <img src="../../../assets/FASWhiteLabelPortal/freemove-logo.svg" width="180" class="d-inline-block align-top" alt="">
        <div (click)="modal.close(false)">
            <i class="fa-solid fa-xmark close-modal-color"></i>
        </div>
    </div>
    <div class="modal-body">
        <p>Clicking Delete will proceed with the elimination of the agreement id: {{idAgreementDelete}}</p>
        <div class="row mt-2">
            <span class="span-error" *ngIf="deleteAgreementDisable()">
            Is not possible to delete the local agreement because it is associated with a country / affiliate!
        </span>
        </div>


    </div>
    <div class="modal-footer footer-modal-background-color">
        <button class="btn btn-primary btn-lg active" (click)="modal.close(true)" [disabled]="deleteAgreementDisable()">Delete</button>
        <button class="btn btn-primary btn-lg active button-reset" (click)="modal.close(false)">Cancel</button>
    </div>
</ng-template>

<ng-template #addNewAgreement let-modal>
    <div class="modal-header header-background-color">
        <img src="../../../assets/FASWhiteLabelPortal/freemove-logo.svg" width="180" class="d-inline-block align-top" alt="">
        <div (click)="modal.close(false)">
            <i class="fa-solid fa-xmark close-modal-color"></i>
        </div>
    </div>
    <div class="modal-body">
        <div class="row mt-2">
            <div class="col-md-6" style="padding-right: 0;">
                <label for="idAgreement">Id *</label>
                <input type="text" [(ngModel)]="idAgreement" [ngClass]="{'input-error': !idAgreement }"
                    class="form-control" id="idAgreement" name="idAgreement" placeholder="IdAgreement">
            </div>
            <div class="col-md-6" style="padding-right: 0;">
                <label for="nameAgreement">Name *</label>
                <input type="text" [(ngModel)]="nameAgreement" [ngClass]="{'input-error': !nameAgreement }"
                    class="form-control" id="nameAgreement" name="nameAgreement" placeholder="NameAgreement">
            </div>
        </div>
        <div class="row mt-4">

            <div class="col-md-6">
                <label >Start Date *</label>
                <ngb-datepicker #dp (dateSelect)="dateSelectStartDate($event)"
                [ngClass]="{'input-error': !dataInizio }"></ngb-datepicker>

            </div>
            

            <div class="col-md-6">
                <label>Expiration Date *</label>
                <ngb-datepicker #dp (dateSelect)="dateSelectExpirationDate($event)"
                [ngClass]="{'input-error': !dataFine }"></ngb-datepicker>
            </div>
        </div>

        <div class="row mt-4">
            <span class="span-error" *ngIf="addAgreementDisable()">Fill in all
                mandatory fields marked with
                * to save</span>
        </div>




    </div>
    <div class="modal-footer footer-modal-background-color mt-2">
        <button class="btn btn-primary btn-lg active btn-sm" [disabled]="addAgreementDisable()" (click)="saveAgreement()">Save</button>
        <button class="btn btn-primary btn-lg active btn-sm button-reset" (click)="modal.close(false)">Cancel</button>
    </div>
</ng-template>